import { ActivityFeed } from 'src/graphql/entities/activity-feed/hooks/use-activity-feed';
import { ActivityFeedTime } from './acitivity-feed-time';
import { ChatActivityContainer } from './chat-activity-container';
import { StyledTypography } from './styled/typography.styled';

export const ExecuteBehaviorActivityMessage = ({ activity }: { activity: ActivityFeed }) => {
  const ruleName = activity.changes.find((c) => c.name === 'name')?.value;
  return (
    <ChatActivityContainer
      icon="flare"
      title={
        <StyledTypography>
          <b>{activity.actor.name}</b> executed rule: <b>{ruleName}</b>{' '}
          <ActivityFeedTime activity={activity} />
        </StyledTypography>
      }
    />
  );
};
